import React, { useEffect, useState } from "react";
import { Alert, Button, Form, Modal, Spinner } from "react-bootstrap";
import validator from "validator";
import { createUser, getAllApplications, getAllDomains } from "../../helpers/api";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getUser } from "../../helpers/localStorage";
const configSystem = require("../../configApp");


export default function AddUser({
  show,
  onCancel,
  onClose,
  onSuccess,
  onFail,
}) {
  const loggedUser = getUser();
  const isSuperUser = loggedUser && (loggedUser.type === configSystem.roles.SUPER_USER || loggedUser.type === configSystem.roles.SUPER_ADMIN);
  // Reservadas al Super Admin: no se ofrecen a nadie mas (y el servidor las
  // descarta igual si alguien manda la peticion por su cuenta).
  const esSuperAdmin = loggedUser && loggedUser.type === configSystem.roles.SUPER_ADMIN;
  const reservadas = configSystem.superAdminOnlyApplications || [];
  const [dueDateRise, setDueDateRise] = useState("");
  const [applications, setApplications] = useState({"applications":[]});
  const [domains, setDomains] = useState([]);
  const [user, setUser] = useState({
    username: "",
    passowrd: "",
    rpassword: "",
    phoneNumber: "",
    personalEmail: "",
    type: configSystem.roles.BASIC_CUSTOMER,
    enabled: true,
    dueDate: "2050-07-20",
    applications: [],
    domains: [],
  });

  const [showLoading, setShowLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [connectionError, setConnectionError] = useState("");
  useEffect(() => {
    setConnectionError("");
    setShowSuccess(false);
  }, [user]);

  useEffect(() => {
    setUser({
      username: "",
      passowrd: "",
      rpassword: "",
      phoneNumber: "",
      personalEmail: "",
      type: configSystem.roles.BASIC_CUSTOMER,
      enabled: true,
      applications: [],
      domains: [],
    });
  }, [show]);

  useEffect(()=>{
          getAllApplications().then((data)=>{
            setApplications(data);
          }).catch((e)=>{
            console.log(e);
          });
          
          getAllDomains().then((data)=>{
            if (data && data.domains && Array.isArray(data.domains)) {
              setDomains(data.domains);
            } else {
              setDomains([]);
            }
          }).catch((e)=>{
            console.log(e);
            setDomains([]);
          });
      },[]);

  useEffect(()=>{
    if(dueDateRise !== ""){
      const date = moment().add(dueDateRise, "M").toDate();
      updateUserInfo({ ...user, dueDate: date });
    }
    
  },[dueDateRise]);

  useEffect(() => {
    const validateInfo = () => {
      let errorInfo = {
        foundError: false,
        email: "",
        password: "",
        rpassword: "",
        phoneNumber: "",
        personalEmail: "",
      };

      if (!validator.isEmail(user.username)) {
        if (user.username !== "") errorInfo.email = "Not valid email!";
        errorInfo.foundError = true;
      }

      if (user.password === "" || typeof user.password === "undefined") {
        errorInfo.foundError = true;
      } else {
        if (validator.isLength(user.password, { min: 0, max: 7 })) {
          if (validator.isLength(user.password, { min: 1, max: 7 }))
            errorInfo.password = "Pasword should at least be 8 characteres!";
          errorInfo.foundError = true;
        }
      }

      if (user.password !== user.rpassword) {
        if (user.rpassword.toString().trim().length > 0)
          errorInfo.rpassword = "Password don't match!";
        errorInfo.foundError = true;
      }

      setErrors(errorInfo);
    };
    validateInfo();
  }, [user]);

  const [errors, setErrors] = useState({
    foundError: false,
    email: "",
    password: "",
    rpassword: "",
    personalEmail: "",
    phoneNumber: ""
  });

  const updateUserInfo = (info) => {
    const data = { ...user, ...info };
    setUser(data);
  };

  const handlerEmail = (e) => {
    e.preventDefault();
    updateUserInfo({ ...user, username: e.target.value });
  };

  const handlerPasword = (e) => {
    e.preventDefault();
    updateUserInfo({ ...user, password: e.target.value ? e.target.value : "" });
  };
  const handlerRPasword = (e) => {
    e.preventDefault();
    updateUserInfo({ ...user, rpassword: e.target.value });
  };

  const handleDueDateRise = (e) => {
    e.preventDefault();
    setDueDateRise(e.target.value);
  };

  const handlerEnable = (e) => {
    updateUserInfo({ ...user, enabled: e.target.checked });
  };

  const handleDueDate = (date) => {
    updateUserInfo({ ...user, dueDate: date });
  }

  const handlerPersonalEmail = (e) => {
    e.preventDefault();
    updateUserInfo({ ...user, personalEmail: e.target.value });
  };

  const handlerPhoneNumber = (e) => {
    e.preventDefault();
    updateUserInfo({ ...user, phoneNumber: e.target.value });
  };

  const handlerSelectedApplication = (e)=> {
    e.preventDefault();
    let app = [];
    for (var i = 0, l = e.target.options.length; i < l; i++) {
      if (e.target.options[i].selected) {
        app.push(e.target.options[i].value);
      }
    }
  
    updateUserInfo({ ...user, applications: app });
  }

  // Alterna una aplicacion con un clic (agrega o quita). Reemplaza al
  // <select multiple>, que era facil de "seleccionar de mas".
  const toggleApplication = (id) => {
    const actuales = (user.applications || []).map(Number);
    const nid = Number(id);
    const nuevas = actuales.includes(nid)
      ? actuales.filter((x) => x !== nid)
      : [...actuales, nid];
    updateUserInfo({ ...user, applications: nuevas });
  };

  const handlerSelectedDomains = (e)=> {
    e.preventDefault();
    let selectedDomains = [];
    for (var i = 0, l = e.target.options.length; i < l; i++) {
      if (e.target.options[i].selected) {
        selectedDomains.push(e.target.options[i].value);
      }
    }
  
    updateUserInfo({ ...user, domains: selectedDomains });
  }

  const saveUser = (e) => {
    e.preventDefault();
    if (!errors.foundError) {
      setShowLoading(true);
      createUser(user)
        .then((response) => {
          setShowLoading(false);
          setShowSuccess(true);
          if (onSuccess) {
            onSuccess();
          }
        })
        .catch((error) => {
          setShowLoading(false);
          setConnectionError(error);
          setShowSuccess(false);
          if (onFail) {
            onFail();
          }
        });
    }
  };

  const form = () => {
    return (
      <>
        <Form.Group className="mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            placeholder="Email"
            value={user.username}
            onChange={handlerEmail}
          />
          <span style={{ color: "red" }}>{errors.email}</span>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="******"
            value={user.password}
            onChange={handlerPasword}
          />
          <span style={{ color: "red" }}>{errors.password}</span>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Repeat Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="******"
            value={user.rpassword}
            onChange={handlerRPasword}
          />
          <span style={{ color: "red" }}>{errors.rpassword}</span>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Check
            type="checkbox"
            label="Enable"
            checked={user.enabled}
            onChange={handlerEnable}
          />
        </Form.Group>

        {isSuperUser && (
          <Form.Group className="mb-3">
            <Form.Label>Role</Form.Label>
            <Form.Control
              as="select"
              value={user.type}
              onChange={(e) => updateUserInfo({ ...user, type: Number(e.target.value) })}
            >
              <option value={configSystem.roles.BASIC_CUSTOMER}>Regular User</option>
              <option value={configSystem.roles.ADMIN}>Admin</option>
            </Form.Control>
          </Form.Group>
        )}

        <Form.Group className="mb-3">
          <Form.Label>Applications</Form.Label>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", maxHeight: "240px", overflowY: "auto", padding: "10px", border: "1px solid #e2e8f0", borderRadius: "10px", background: "#f8fafc" }}>
            {applications.applications
              .filter((option) => esSuperAdmin || !reservadas.includes(Number(option.id)))
              .map((option) => {
                const activa = (user.applications || []).map(Number).includes(Number(option.id));
                return (
                  <button
                    type="button"
                    key={option.id}
                    onClick={() => toggleApplication(option.id)}
                    aria-pressed={activa}
                    title={activa ? "Quitar " + option.tittle : "Agregar " + option.tittle}
                    style={{
                      display: "inline-flex", alignItems: "center", gap: "7px",
                      padding: "7px 14px", borderRadius: "999px",
                      border: "1.5px solid " + (activa ? "#16a34a" : "#cbd5e1"),
                      background: activa ? "#dcfce7" : "#ffffff",
                      color: activa ? "#166534" : "#334155",
                      fontSize: "0.85rem", fontWeight: activa ? 600 : 500,
                      cursor: "pointer", transition: "all .15s",
                    }}
                  >
                    <span style={{ fontWeight: 700 }}>{activa ? "✓" : "+"}</span>
                    {option.tittle}
                  </button>
                );
              })}
          </div>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Additional Domains</Form.Label>
          <Form.Control as="select" multiple value={user.domains} onChange={handlerSelectedDomains} >
            {(Array.isArray(domains) ? domains : []).filter(d => d.enabled).map((domain) => (
              <option key={domain._id} value={domain._id}>
                {domain.name}   
              </option>
            ))}  
          </Form.Control>
          <Form.Text className="text-muted">
            Hold Ctrl (Windows) or Cmd (Mac) to select multiple domains
          </Form.Text>
        </Form.Group>

        <Form.Group className="m-3">
          <Form.Label>Due Date</Form.Label><br/>
          <DatePicker
                selected={user.dueDate}
                onChange={(date) => handleDueDate(date)}
                highlightDates={[moment(user.dueDate)]}
                isClearable={true}
              />
          <select value={dueDateRise} onChange={handleDueDateRise}>
                <option value="0"></option>
                <option value="1">1 Month</option>
                <option value="2">2 Months</option>
                <option value="3">3 Month</option>
                <option value="4">4 Months</option>
                <option value="5">5 Month</option>
                <option value="6">6 Months</option>
                <option value="7">7 Month</option>
                <option value="8">8 Months</option>
                <option value="9">9 Month</option>
                <option value="10">10 Months</option>
                <option value="11">11 Month</option>
                <option value="12">1 Years</option>
              </select>
        </Form.Group>
      </>
    );
  };

  return (
    <Modal show={show} onHide={onCancel} animation={false} centered={true}>
      <Modal.Header closeButton>
        <Modal.Title>Add New User</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {connectionError !== "" ? (
          <Alert variant="warning">{connectionError}</Alert>
        ) : (
          <></>
        )}
        {showSuccess ? <Alert variant="success">User Created!</Alert> : <></>}
        {form()}
      </Modal.Body>
      <Modal.Footer>
        {!showSuccess ? (
          <>
            <Button
              variant="secondary"
              onClick={() => {
                onCancel();
              }}
            >
              Cancel
            </Button>
            <Button variant="primary" onClick={saveUser} disabled={showLoading}>
              {showLoading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <></>
              )}
              Save
            </Button>
          </>
        ) : (
          <Button
            variant="secondary"
            onClick={() => {
              onCancel();
            }}
          >
            Close
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
